import * as React from 'react';

import {
  default as MuiButton,
  ButtonProps as MuiButtonProps,
} from '@material-ui/core/Button';

import clsx from 'clsx';
import { useStyles } from './Button.styles';

type ButtonType = 'round';
type Background = 'transparent' | 'gradient' | 'black';

type CustomButtonProps = {
  buttonType?: ButtonType;
  background?: Background;
};

type ButtonProps = MuiButtonProps & CustomButtonProps;

const Button: React.FC<ButtonProps> = ({
  children,
  className,
  buttonType,
  background,
  ...rest
}) => {
  const styles = useStyles();

  const getStylesByButtonType = (buttonType?: ButtonType) => {
    switch (buttonType) {
      case 'round':
        return styles.round;
    }
  };

  const getStylesByBackground = (background?: Background) => {
    switch (background) {
      case 'gradient':
        return styles.gradient;
      case 'transparent':
        return styles.transparent;
      case 'black':
        return styles.black;
    }
  };

  return (
    <MuiButton
      classes={{
        root: clsx(
          styles.root,
          getStylesByButtonType(buttonType),
          getStylesByBackground(background),
          className
        ),
      }}
      {...rest}
    >
      {children}
    </MuiButton>
  );
};

export default Button;
